import {
  loopbackGet,
  loopbackPost,
  loopbackDelete,
  LoopbackFilter,
  loopbackPatch,
} from '..';

import { Enrollment, Institute, QuipUser } from '../../redux/types';

export const getInstitutes = (filter?: {[key: string]: unknown}): Promise<Institute[]> => {
  const filterStr = filter ? `?filter=${JSON.stringify(filter)}` : '';
  const uri = 'Institutes'.concat(filterStr);
  return loopbackGet(uri);
};

export const addInstitute = (institute: Institute): Promise<Institute> => {
  const uri = 'Institutes';
  return loopbackPost(uri, institute);
};

export const addInstituteFirstTime = (institute: Institute): Promise<Institute> => {
  const uri = 'Institutes/addInstitute';
  return loopbackPost(uri, institute);
};

export const deleteInstitute = (institute: Institute): Promise<Institute> => {
  const uri = 'Institutes';
  return loopbackDelete(`${uri}/${institute.id}`);
};

export const updateInstitute = (institute: Institute): Promise<Institute> => loopbackPatch(`Institutes/${institute.id}`, institute);

type AddUserPayload = {
  userIds: number[]
}

/**
 * This api update all user's QuipUser.instituteId to the provided Id.
 * */
export const addUsersToInstitute = (
  instituteId: number, body: AddUserPayload,
): Promise<QuipUser[]> => {
  const uri = `Institutes/${instituteId}/addUsers`;
  return loopbackPost(uri, { body });
};

export const approveInstitutes = (instituteIds: number[]): Promise<Institute[]> => {
  const uri = 'Institutes/approveInstitutes';
  return loopbackPost(uri, { instituteIds });
};

export const exportInstitutes = (): Promise<string[][]> => loopbackGet('institutes/exportInstitutes');

export const getInstituteEnrollments = (instituteId: number): Promise<Enrollment[]> => loopbackGet(`institutes/${instituteId}/enrollments`);

export const geocodeUnlocatedInstitutes = (): Promise<void> => loopbackPost('Institutes/geocodeUnlocated');
